import React from "react";
import { CircularProgress } from "@mui/material";

const LoadingCircularProgress = () => {

    return <div
        style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000, // Ensure spinner is on top of other content
        }}
    >
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.8)", // Optional: adds a semi-transparent background
                borderRadius: "4px", // Optional: for a rounded look
                padding: "10px", // Optional: adds padding around the spinner
            }}
        >
            <CircularProgress size={"2rem"} />
            <span>Loading...</span>
        </div>
    </div>
};

export default LoadingCircularProgress;
